
class PluginsClass {

}

export const Plugins: E5Plugins = {} as any;//new PluginsClass() as any;